import axios from "axios";
import Toast from "../../../shared/Toast";

// API Base URL from environment variable
const API_BASE_URL = process.env.REACT_APP_MAIN_URL || "http://localhost:8080";

//console.log("🔧 Alert Actions - API Base URL:", API_BASE_URL);

// Action Types
export const GET_ACTIVE_ALERT_REQUEST = "GET_ACTIVE_ALERT_REQUEST";
export const GET_ACTIVE_ALERT_SUCCESS = "GET_ACTIVE_ALERT_SUCCESS";
export const GET_ACTIVE_ALERT_FAILURE = "GET_ACTIVE_ALERT_FAILURE";

export const GET_ALERT_SETTINGS_REQUEST = "GET_ALERT_SETTINGS_REQUEST";
export const GET_ALERT_SETTINGS_SUCCESS = "GET_ALERT_SETTINGS_SUCCESS";
export const GET_ALERT_SETTINGS_FAILURE = "GET_ALERT_SETTINGS_FAILURE";

export const UPDATE_ALERT_SETTINGS_REQUEST = "UPDATE_ALERT_SETTINGS_REQUEST";
export const UPDATE_ALERT_SETTINGS_SUCCESS = "UPDATE_ALERT_SETTINGS_SUCCESS";
export const UPDATE_ALERT_SETTINGS_FAILURE = "UPDATE_ALERT_SETTINGS_FAILURE";

export const DISMISS_ALERT = "DISMISS_ALERT";

// Get Active Alert (Public - No Auth Required)
export const getActiveAlert = () => (dispatch) => {
  //console.log("🔍 GET ACTIVE ALERT - Starting request");
  dispatch({ type: GET_ACTIVE_ALERT_REQUEST });
  
  axios.get(`${API_BASE_URL}api/alerts/active`)
    .then((response) => {
      //console.log("✅ GET ACTIVE ALERT - Response:", response.data);
      if (response.data.success && response.data.data) {
        dispatch({
          type: GET_ACTIVE_ALERT_SUCCESS,
          payload: response.data.data
        });
      } else {
        dispatch({
          type: GET_ACTIVE_ALERT_SUCCESS,
          payload: null
        });
      }
    })
    .catch((error) => {
      console.error("❌ GET ACTIVE ALERT - Error:", error);
      console.error("❌ GET ACTIVE ALERT - Error response:", error.response);
      dispatch({
        type: GET_ACTIVE_ALERT_FAILURE,
        payload: error.message
      });
    });
};

// Get Alert Settings (Admin Only)
export const getAlertSettings = (token) => (dispatch) => {
  //console.log("🔍 GET ALERT SETTINGS - Starting request");
  //console.log("🔍 GET ALERT SETTINGS - Token exists:", !!token);
  //console.log("🔍 GET ALERT SETTINGS - URL:", `${API_BASE_URL}api/alerts/settings`);
  
  dispatch({ type: GET_ALERT_SETTINGS_REQUEST });
  
  axios.get(`${API_BASE_URL}api/alerts/settings`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  })
    .then((response) => {
      //console.log("✅ GET ALERT SETTINGS - Response:", response);
      //console.log("✅ GET ALERT SETTINGS - Response data:", response.data);
      //console.log("✅ GET ALERT SETTINGS - Success flag:", response.data.success);
      
      // Check if response is successful
      if (response.data && response.data.success) {
        //console.log("✅ GET ALERT SETTINGS - Dispatching success with payload:", response.data.data);
        dispatch({
          type: GET_ALERT_SETTINGS_SUCCESS,
          payload: response.data.data
        });
      } else {
        console.warn("⚠️ GET ALERT SETTINGS - Backend returned success: false");
        Toast.error(response.data?.message || "Failed to load alert settings");
        dispatch({
          type: GET_ALERT_SETTINGS_FAILURE,
          payload: response.data?.message || "Unknown error"
        });
      }
    })
    .catch((error) => {
      console.error("❌ GET ALERT SETTINGS - Catch block triggered");
      console.error("❌ GET ALERT SETTINGS - Error:", error);
      console.error("❌ GET ALERT SETTINGS - Error response:", error.response);
      console.error("❌ GET ALERT SETTINGS - Error status:", error.response?.status);
      console.error("❌ GET ALERT SETTINGS - Error data:", error.response?.data);
      
      Toast.error("Failed to load alert settings");
      dispatch({
        type: GET_ALERT_SETTINGS_FAILURE,
        payload: error.message
      });
    });
};

// Update Alert Settings (Admin Only)
export const updateAlertSettings = (alertData, token) => (dispatch) => {
  //console.log("🔍 UPDATE ALERT SETTINGS - Starting request");
  //console.log("🔍 UPDATE ALERT SETTINGS - Data:", alertData);
  //console.log("🔍 UPDATE ALERT SETTINGS - Token exists:", !!token);
  //console.log("🔍 UPDATE ALERT SETTINGS - URL:", `${API_BASE_URL}api/alerts/settings`);
  
  dispatch({ type: UPDATE_ALERT_SETTINGS_REQUEST });
  
  axios.post(`${API_BASE_URL}api/alerts/settings`, alertData, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json"
    }
  })
    .then((response) => {
      //console.log("✅ UPDATE ALERT SETTINGS - Response:", response);
      //console.log("✅ UPDATE ALERT SETTINGS - Response data:", response.data);
      
      // Check if response is successful
      if (response.data && response.data.success) {
        //console.log("✅ UPDATE ALERT SETTINGS - Dispatching success");
        dispatch({
          type: UPDATE_ALERT_SETTINGS_SUCCESS,
          payload: response.data.data
        });
        Toast.success("Alert settings updated successfully");
      } else {
        console.warn("⚠️ UPDATE ALERT SETTINGS - Backend returned success: false");
        Toast.error(response.data?.message || "Failed to update alert settings");
        dispatch({
          type: UPDATE_ALERT_SETTINGS_FAILURE,
          payload: response.data?.message || "Unknown error"
        });
      }
    })
    .catch((error) => {
      console.error("❌ UPDATE ALERT SETTINGS - Catch block triggered");
      console.error("❌ UPDATE ALERT SETTINGS - Error:", error);
      console.error("❌ UPDATE ALERT SETTINGS - Error response:", error.response);
      console.error("❌ UPDATE ALERT SETTINGS - Error status:", error.response?.status);
      console.error("❌ UPDATE ALERT SETTINGS - Error data:", error.response?.data);
      
      const errorMsg = error.response?.data?.message || "Failed to update alert settings";
      Toast.error(errorMsg);
      dispatch({
        type: UPDATE_ALERT_SETTINGS_FAILURE,
        payload: error.message
      });
    });
};

// Dismiss Alert (Local State Only)
export const dismissAlert = () => ({
  type: DISMISS_ALERT
});